<script>
/* import { authComputed } from '@state/helpers' */
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from 'moment/moment'
import CreateNew from './createNew.vue'

export default {
	components: {
		VuePerfectScrollbar,
		CreateNew
	},
	props: {
		isMenuOpened: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			notificationData: [],
			notificationCount: 0,
			dropdownList: [],
			isFullScreen: false
		}
	},
/* 	computed: {
		...authComputed,
	}, */
	methods: {
		toggleMenu() {
			this.$parent.toggleMenu()
		},
		toggleRightSidebar() {
			this.$parent.toggleRightSidebar()
		},
		toggleLanguage(lang){
			this.$cookie.set('language', lang, 7);
			this.$i18n.locale = lang
			this.$store.dispatch('user/updateLanguage', {lang:lang})
		},
		formatDateFromNow(date){
			return moment(date).fromNow()
		},
		async fetchData(){
			if(this.user.avatar)
				this.$refs['headerAvatar'].src = this.user.avatar

			this.$store.dispatch('webcrawler/paginateWebcrawlerLog')
			.then(res => {
				this.notificationData = res.data.data.data
				this.notificationCount = res.data.count
				this.notificationData = this.notificationData.map((el) => ({_id: el._id, description: el.description, fromNow: this.formatDateFromNow(el.createdAt), success: el.success}))
			})
      .catch(err => {
        console.log(err);
			})
		},
		updateUnreadNotification(){
			this.$store.dispatch('webcrawler/updateUnreadNotification')
			.then( () => {
				this.notificationCount = 0
			})
      .catch(err => {
        console.log(err);
			})
		},
		toggleNotificationDropdown() {
			this.$refs.notificationDropdown.show(true); // force open
		},
		mountedDropdownList() {
			let list = ['candidate', 'job', 'company']
			let initialArray = [
				{ name: 'Candidate', icon: 'users', label: 'candidate.singular'},
        { name: 'Job', icon: 'briefcase', label: 'job.singular'},
        { name: 'Company', icon: 'map-pin', label: 'company.singular'}
			]
			
			for(var key in list) {
				let value = list[key]
				let data = {}

				if(this.role_modules.some(item => item.value == `${value}.create`)) {
					data = initialArray.filter( el => el.name.toLocaleLowerCase() == value )
				}

				if(data.length)
					this.dropdownList.push(...data)
			}
		},
		toggleFullScreen() {
			var elem = document.getElementById("html");
			if ((document.fullScreenElement !== undefined && document.fullScreenElement === null) || (document.msFullscreenElement !== undefined && document.msFullscreenElement === null) || (document.mozFullScreen !== undefined && !document.mozFullScreen) || (document.webkitIsFullScreen !== undefined && !document.webkitIsFullScreen)) {
				if (elem.requestFullScreen) {
						elem.requestFullScreen();
				} else if (elem.mozRequestFullScreen) {
						elem.mozRequestFullScreen();
				} else if (elem.webkitRequestFullScreen) {
						elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
				} else if (elem.msRequestFullscreen) {
						elem.msRequestFullscreen();
				}
				this.isFullScreen = true
			} else {
				if (document.cancelFullScreen) {
						document.cancelFullScreen();
				} else if (document.mozCancelFullScreen) {
						document.mozCancelFullScreen();
				} else if (document.webkitCancelFullScreen) {
						document.webkitCancelFullScreen();
				} else if (document.msExitFullscreen) {
						document.msExitFullscreen();
				}
				this.isFullScreen = false
			}
		}
	},
	mounted() {
    this.fetchData()
		this.mountedDropdownList()
	},
}
</script>

<template>
	<!-- Topbar Start -->
	<div class="navbar navbar-expand flex-column flex-md-row navbar-custom">
		<div class="w-100 d-flex px-5">
			<ul
				class="navbar-nav bd-navbar-nav flex-row list-unstyled menu-left mb-0"
			>
				<li class>
					<button
						class="button-menu-mobile open-left disable-btn"
						:class="{ open: isMenuOpened }"
						@click="toggleMenu"
					>
						<feather type="menu" class="menu-icon align-middle"></feather>
						<feather type="x" class="close-icon"></feather>
					</button>
				</li>
			</ul>

			<CreateNew v-if="dropdownList.length" :dropdownList="dropdownList"/>

			<ul
				class="navbar-nav flex-row ml-auto d-flex list-unstyled topnav-menu float-right mb-0"
			>

				<button type="button" class="btn2 btn2-tertiary" @click="toggleFullScreen()">
					<feather v-if="!isFullScreen" type="maximize" class="maximize-icon align-middle mx-2 text-muted"></feather>
					<feather v-else type="minimize" class="minimize-icon align-middle mx-2 text-muted"></feather>
				</button>

				<b-nav-item-dropdown
					id="globe-tooltip"
					right
					variant="black"
					class="dropdown d-none d-lg-block"
					no-caret
					v-if="1==0"
				>
					<template v-slot:button-content>
						<feather class="btn2-tertiary text-muted" type="globe"></feather>
					</template>
					<b-tooltip target="globe-tooltip" placement="left"
						>Change language</b-tooltip
					>
					<!-- item-->
					<b-dropdown-item href="javascript:void(0);" class="notify-item"
						@click="toggleLanguage('us')">
						<img
							src="@assets/images/flags/us.jpg"
							alt="user-image"
							class="mr-2"
							height="12"
						/> 
						<span class="align-middle">English (US)</span>
					</b-dropdown-item>

					<b-dropdown-item href="javascript:void(0);" class="notify-item"
					@click="toggleLanguage('jp')">
						<img
							src="@assets/images/flags/japan.jpg"
							alt="user-image"
							class="mr-2"
							height="12"
						/>
						<span class="align-middle">Japanese</span>
					</b-dropdown-item>

				</b-nav-item-dropdown>


				<button id="bell-notification" type="button" class="btn2 btn2-tertiary" @click="toggleNotificationDropdown">
					<feather type="bell" class="align-middle btn2-tertiary text-muted mx-2"></feather>
				</button>
				<b-nav-item-dropdown
					ref="notificationDropdown"
					id="bell-notification"
					right
					variant="white"
					class="notification-list position-absolute ml-5 pl-3"
					style="top:60%"
					menu-class="dropdown-lg"
					@shown="updateUnreadNotification"
				>
					<!-- <template v-slot:button-content>
						<span v-if="notificationCount > 0" class="noti-icon-badge"></span>
					</template> -->
					<b-tooltip target="bell-notification" placement="left"
						>{{notificationCount}} new unread notifications</b-tooltip
					>
					<!-- item-->
					<b-dropdown-text class="noti-title border-bottom pb-2" tag="div">
						<h5 class="m-0 font-size-16">
							Notification
						</h5>
					</b-dropdown-text>

					<VuePerfectScrollbar class="noti-scroll">
						<!-- items-->
						<b-dropdown-text
							href="javascript:void(0);"
							class="notify-item border-bottom active"
							v-for="notification in notificationData" :key="notification._id"
						>
							<div :class="`notify-icon ${notification.success ? 'bg-success':'bg-danger'}`">
								<i class="uil uil-comment-message"></i>
							</div>
							<p class="notify-details">
								{{notification.description}}
								<small class="text-muted">
									{{notification.fromNow}}
								</small>
							</p>
						</b-dropdown-text>
					</VuePerfectScrollbar>
					<!-- All-->
					<b-dropdown-text
						href="javascript:void(0);"
						class="text-center text-primary notify-item notify-all border-top"
					>
						<router-link
							tag="a"
							to="/administration/webcrawler_log"
						>	View All </router-link>
						<i class="fi-arrow-right"></i>
					</b-dropdown-text>
				</b-nav-item-dropdown>

				<b-nav-item-dropdown
					variant="white"
					class="m-auto"
					right
				>
					<template v-slot:button-content>
						<div class="media d-flex justify-content-center" style="width:52px">
							<img
								:src="user.avatar? user.avatar : 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973461_960_720.png'"
								class="avatar-sm rounded-lg mr-2"
								alt="JINZ.AI"
								ref="headerAvatar"
								/>
						</div>
						<!-- <span class="noti-icon-badge"></span> -->
					</template>
					<div class="media px-3 pt-2">
						<img
								:src="user.avatar? user.avatar : 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973461_960_720.png'"
							class="avatar-sm rounded-lg mr-2"
							alt="JINZ.AI"
							ref="headerAvatar"
							/>
						<div class="media-body d-none d-lg-block text-left" style="width:200px">
							<h6 class="mt-0 mb-0 " >{{user.full_name || user.company_name}}</h6>
							<div>
								<!-- <div class="pro-user-desc">{{ user.role.role | capitalize}}</div> -->
								<div class="pro-user-desc">{{ user.role.name }}</div>
							</div>
						</div>
					</div>
					<b-dropdown-divider></b-dropdown-divider>

					<router-link
						tag="b-dropdown-item"
						:to="'/administration/user/view?id=' + user.id" 
					>
						<feather
							type="user"
							class="icon-dual icon-xs mr-2 align-middle"
						></feather>
						<span>My Account</span>
					</router-link>

					<b-dropdown-divider></b-dropdown-divider>

					<router-link
						tag="b-dropdown-item"
						:to="'/finance/'"
					>
						<feather
							type="bar-chart"
							class="icon-dual icon-xs mr-2 align-middle"
						></feather>
						<span>Finance</span>
					</router-link>

					<b-dropdown-divider></b-dropdown-divider>

					<b-dropdown-item href="/logout" class="notify-item" @click.prevent="logout">
						<feather
							type="log-out"
							class="icon-dual icon-xs mr-2 align-middle"
						></feather>
						<span>Logout</span>
					</b-dropdown-item>
					
				</b-nav-item-dropdown>

			</ul>
		</div>
	</div>
	<!-- end Topbar -->
</template>

<style lang="scss">
.custom-user-profile{

	.pro-user-name{
		padding:0;
		line-height:normal;
	}
	.pro-user-desc{
		line-height:normal;
		padding:0;
		font-size: 12px;
	}
}
.noti-scroll {
	height: 220px;
}
.ps > .ps__scrollbar-y-rail {
	width: 8px !important;
	background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
	width: 6px !important;
}
.button-menu-mobile {
	outline: none !important;
}
</style>
